import {RESET_PAGE} from '../actions'

export const defaultState = {
	isFetchingItems: false,
	isFetchingCount: false,
	count: null,
	items: null,
	filter: {}
};

const paginate = ({types}) => {
	if (!Array.isArray(types) || (types.length !== 6 && types.length !== 3)) {
		throw new Error('Expected types to be an array of 3 or 6 (with counting) elements.')
	}
	if (!types.every(t => typeof t === 'string')) {
		throw new Error('Expected types to be strings.')
	}

	const [requestType, successType, failureType, countRequestType, countSuccessType, countFailureType] = types;

	const updatePagination = (state = defaultState, action) => {
		switch (action.type) {
			case requestType:
				return {
					...state,
					isFetchingItems: true
				};
			case successType:
				return {
					...state,
					isFetchingItems: false,
					items: action.response.data,
					filter: action.filter
				};
			case failureType:
				return {
					...state,
					isFetchingItems: false,
					items: []
				};
			case countRequestType:
				return {
					...state,
					isFetchingCount: true
				};
			case countSuccessType:
				return {
					...state,
					isFetchingCount: false,
					count: action.response.data,
					filter: action.filter
				};
			case countFailureType:
				return {
					...state,
					isFetchingCount: false
				};
			case RESET_PAGE:
				return Object.assign(defaultState, {filter: {}});
			default:
				return state
		}
	};

	return (state = {}, action) => {
		// Update pagination by key
		switch (action.type) {
			case requestType:
			case successType:
			case failureType:
			case countRequestType:
			case countSuccessType:
			case countFailureType:
			case RESET_PAGE:
				if (!action.name || action.name === requestType) {
					const key = 0;
					return {
						...state,
						[key]: updatePagination(state[key], action)
					}
				} else {
					return state
				}
			default:
				return state
		}
	}
};

export default paginate